(function () {
  function initHero3DLogo(container) {
    if (!window.THREE || container.dataset.hero3dReady) return;
    var logoSrc = container.getAttribute('data-logo-src');
    if (!logoSrc) return;
    container.dataset.hero3dReady = 'true';

    var width = container.clientWidth || 320;
    var height = container.clientHeight || width;

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(35, width / height, 0.1, 100);
    camera.position.set(0, 0, 6);

    var renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    if (renderer.outputEncoding !== undefined && THREE.sRGBEncoding !== undefined) {
      renderer.outputEncoding = THREE.sRGBEncoding;
    }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(width, height);
    container.appendChild(renderer.domElement);

    var ambient = new THREE.AmbientLight(0xffffff, 0.8);
    scene.add(ambient);
    var key = new THREE.PointLight(0xffffff, 1.2);
    key.position.set(4, 5, 6);
    scene.add(key);
    var rim = new THREE.PointLight(0xff3d94, 1);
    rim.position.set(-5, -3, 4);
    scene.add(rim);

    var loader = new THREE.TextureLoader();
    if (loader.setCrossOrigin) loader.setCrossOrigin('anonymous');

    loader.load(logoSrc, function (texture) {
      if (texture.encoding !== undefined && THREE.sRGBEncoding !== undefined) {
        texture.encoding = THREE.sRGBEncoding;
      }

      var faceMat = new THREE.MeshStandardMaterial({
        map: texture,
        transparent: true,
        alphaTest: 0.04,
        metalness: 0.15,
        roughness: 0.35,
      });
      var edgeMat = new THREE.MeshStandardMaterial({
        color: 0xd2126c,
        transparent: true,
        opacity: 0,
        depthWrite: false,
      });

      var imgAspect =
        texture.image && texture.image.width
          ? texture.image.width / texture.image.height
          : 1.7857;
      var plateWidth = 3.4;
      var plateHeight = plateWidth / imgAspect;
      var plateDepth = 0.04;

      var geometry = new THREE.BoxGeometry(plateWidth, plateHeight, plateDepth);
      var mesh = new THREE.Mesh(geometry, [
        edgeMat,
        edgeMat,
        edgeMat,
        edgeMat,
        faceMat,
        faceMat,
      ]);
      scene.add(mesh);

      var reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var speed = reduceMotion ? 0 : 0.012;
      var rafId;

      function animate() {
        mesh.rotation.y += speed;
        renderer.render(scene, camera);
        rafId = requestAnimationFrame(animate);
      }
      animate();

      container.dataset.hero3dRaf = rafId;
    });

    function onResize() {
      var w = container.clientWidth || width;
      var h = container.clientHeight || w;
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      renderer.setSize(w, h);
    }
    window.addEventListener('resize', onResize);
  }

  function boot() {
    var containers = document.querySelectorAll('[data-hero-3d-logo]');
    containers.forEach(function (c) {
      initHero3DLogo(c);
    });
  }

  function whenThreeReady(attempt) {
    attempt = attempt || 0;
    if (window.THREE || attempt > 40) {
      boot();
      return;
    }
    setTimeout(function () {
      whenThreeReady(attempt + 1);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      whenThreeReady(0);
    });
  } else {
    whenThreeReady(0);
  }
})();
